import { mdiAccountCircle ,mdiCreditCardClockOutline,mdiChartLine,mdiCurrencyTry ,mdiBell  } from '@mdi/js';
import {mdiHomeOutline ,mdiAccountGroupOutline,mdiHomePercentOutline,mdiHomeClockOutline,mdiBriefcaseOutline  ,mdiPostOutline ,mdiCardAccountMailOutline   } from '@mdi/js';
// import { mdiHeart ,mdiMagnify,mdiCog   } from '@mdi/js';

export const headerRoutes = [
  {
    name: "Anasayfa",
    icon:mdiHomeOutline ,
    link: "/",
  },
  {
    name: "Hakkımızda",
    icon: mdiAccountGroupOutline ,
    link: "/hakkimizda",
  },
  {
    name: "Yatırımlar",
    icon: mdiHomePercentOutline ,
    link: "/yatirimlar",
    child:{
      name: "Satış Bitti",
      link: "/satis-bitti"
    }
  },
  {
    name: "Fırsatlar",
    icon: mdiHomeClockOutline ,
    link: "/firsatlar",
    child:{
      name: "Gelecek Projeler",
      link: "/firsatlar/gelecek-projeler"
    }
  },
  {
    name: "Nasıl Çalışır",
    icon: mdiBriefcaseOutline ,
    link: "/nasil-calisir",
  },
  {
    name: "Blog",
    icon: mdiPostOutline ,
    link: "/blog",
    child:{
      name: "BlogDetail",
      link: "/blog/:slugTitle_:articleId"
    }
  },
  {
    name: "İletişim",
    icon: mdiCardAccountMailOutline ,
    link: "/iletisim",
    child:{
      name: "İletişim",
      link: "/iletisim"
    }
  },
];
export const footerRoutes = [
  {
    name: "Anasayfa",
    link: "/",
  },
  {
    name: "Hakkımızda",
    link: "/hakkimizda",
  },
  {
    name: "Yatırımlar",
    link: "/yatirimlar",
  },
  {
    name: "Fırsatlar",
    link: "/firsatlar",
  },
  {
    name: "Nasıl Çalışır",
    link: "/nasil-calisir",
  },
  {
    name: "Blog",
    link: "/blog",
  },
  {
    name: "S.S.S.",
    link: "/sikca-sorulan-sorular",
  },
  {
    name: "İletişim",
    link: "/iletisim",
  },
];

export const profileRoutes = [
  { id: 1, route: '/profil/kisisel-bilgilerim', text: 'Kişisel Bilgilerim', icon: mdiAccountCircle  },
  { id: 2, route: '/profil/satin-alma-sureci', text: 'Satın Alma Süreci', icon: mdiCreditCardClockOutline },
  { id: 3, route: '/profil/portfoyum', text: 'Portföyüm', icon: mdiChartLine  },
  // { id: 4, route: '/profil/favori-ilanlarim', text: 'Favori İlanlarım', icon: mdiHeart },
  // { id: 5, route: '/profil/kaydedilen-aramalar', text: 'Kaydedilen Aramalar', icon: mdiMagnify  },
  { id: 6, route: '/profil/kira-gelirlerim', text: 'Kira Gelirlerim', icon: mdiCurrencyTry  },
  { id: 7, route: '/profil/bildirimler', text: 'Bildirimler', icon: mdiBell  },
  // { id: 9, route: '/profil/ayarlar', text: 'Ayarlar', icon: mdiCog },
];